import { Avatar, IconButton } from '@mui/material';
import { AccordionArrowIcon } from 'Images';

interface IAccordionArrow {
  isOpen?: boolean;
}

export const AccordionArrow = (props: IAccordionArrow) => {
  return (
    <IconButton>
      <Avatar
        src={AccordionArrowIcon}
        sx={{
          width: '20px',
          height: '20px',
          transform: props.isOpen ? `rotate(180deg)` : `rotate(0deg)`,
          transition: 'transform 0.3s',
        }}
        alt={''}
      />
    </IconButton>
  );
};
